import cn from 'classnames'
import React, { useState } from 'react'

import Icon from 'components/uiKit/Icon'
import { testProps } from 'utils/test/qaData'

import { IconButton } from '../Button'
import { KitSize } from '../KitTypes'
import * as s from './Notification.module.scss'
import { useRemoveNotification } from './NotificationRoot'
import type { INotificationProps } from './types'
import { NotificationType } from './types'

const notificationIcon = {
  error: (
    <span className={cn(s.icon, s.error)}>
      <Icon name='alertFailWhite' size={KitSize.S} />
    </span>
  ),
  success: (
    <span className={cn(s.icon, s.success)}>
      <Icon name='alertCheck' size={KitSize.S} />
    </span>
  ),
  warning: (
    <span className={cn(s.icon)}>
      <Icon name='alertDanger' size={KitSize.S} />
    </span>
  ),
  info: (
    <span className={cn(s.icon, s.info)}>
      <Icon name='alertDanger' size={KitSize.S} />
    </span>
  ),
}
const Notification: React.FC<INotificationProps> = ({ id, type, message, className }) => {
  const removeNotification = useRemoveNotification()
  const [visible, setVisible] = useState(true)
  const handleClose = () => {
    setVisible(false)
    removeNotification(id)
  }
  if (!visible) {
    return null
  }

  const icon = notificationIcon[type]

  return (
    <div {...testProps({ el: 'notification' })} className={cn(s.notification, s[type], className)}>
      <div className={s.block}>
        {icon}
        <div className={s.content}>
          <div {...testProps({ el: 'notificationMessage' })} className={cn(s.message, s[type])}>
            {message}
          </div>
          <div className={cn(s.divider, { [s.opacity]: type === NotificationType.error })} />
        </div>
      </div>
      <div className={cn(s.closeIconWrapper)} onClick={handleClose}>
        <div className={cn(s.closeIcon, s[type])}>
          <IconButton
            icon='otherClose'
            name='closeNotification'
            size={KitSize.XS}
            styleType='ghost'
          />
        </div>
      </div>
    </div>
  )
}
export default Notification
